import { render, staticRenderFns } from "./AdvertisingFeeImport.vue?vue&type=template&id=37ffa5d2&scoped=true&"
import script from "./AdvertisingFeeImport.vue?vue&type=script&lang=js&"
export * from "./AdvertisingFeeImport.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisingFeeImport.vue?vue&type=style&index=0&id=37ffa5d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ffa5d2",
  null
  
)

export default component.exports